export class CodigoTipoMoneda {
    public CodigoMoneda?: string;
    public TipoCambio?: number;
}
